export default {
  props: {
    /**
      * ID of resource managed by component
      */
    resourceId: {type: Number}
  }
};
